export interface GunProtocol {
  name: string;
  code: string;
  image?: string;
}

export const guns: GunProtocol[] = [
  {
    name: 'AK-47',
    code: 'ak47',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_AK-47_Inventory_sgjrkg.webp'
  },
  {
    name: 'M4A4 / M4A1',
    code: 'm4a1',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_M4A1-S_Inventory_jteazn.webp'
  },
  {
    name: 'SG 556',
    code: 'sg556',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_SG_553_Inventory_ndleri.webp'
  },
  {
    name: 'AUG',
    code: 'aug',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_AUG_Inventory_fdcvkk.webp'
  },
  {
    name: 'Famas',
    code: 'famas',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_FAMAS_Inventory_hekm6h.webp'
  },
  {
    name: 'Galil',
    code: 'galilar',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Galil_AR_Inventory_rbmuen.webp'
  },
  {
    name: 'AWP',
    code: 'awp',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_AWP_Inventory_stuqcb.webp'
  },
  {
    name: 'SSG',
    code: 'ssg08',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_SSG_08_Inventory_ij7kux.webp'
  },
  {
    name: 'G3SG1',
    code: 'g3sg1',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_G3SG1_Inventory_o7snpb.webp'
  },
  {
    name: 'SCAR 20',
    code: 'scar20',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_SCAR-20_Inventory_mop0mw.webp'
  },
  {
    name: 'MAC 10',
    code: 'mac10',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_MAC-10_Inventory_db7fyn.webp'
  },
  {
    name: 'MP9',
    code: 'mp9',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_MP9_Inventory_szveos.webp'
  },
  {
    name: 'MP7',
    code: 'mp7',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_MP7_Inventory_nacs5c.webp'
  },
  {
    name: 'UMP45',
    code: 'ump45',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_UMP-45_Inventory_lnjdvm.webp'
  },
  {
    name: 'Bizon',
    code: 'bizon',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_PP-Bizon_Inventory_mlrqin.webp'
  },
  {
    name: 'P90',
    code: 'p90',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_P90_Inventory_mna4eh.webp'
  },
  {
    name: 'Nova',
    code: 'nova',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Nova_Inventory_vzfby5.webp'
  },
  {
    name: 'XM-1014',
    code: 'xm1014',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_XM1014_Inventory_spyagl.webp'
  },
  {
    name: 'Sawed-Off',
    code: 'sawedoff',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Sawed-Off_Inventory_ftqkzf.webp'
  },
  {
    name: 'MAG-7',
    code: 'mag7',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_MAG-7_Inventory_okg7va.webp'
  },
  {
    name: 'M249',
    code: 'm249',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_M249_Inventory_igkf1p.webp'
  },
  {
    name: 'Negev',
    code: 'negev',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Negev_Inventory_us3ni8.webp'
  },
  {
    name: 'P250',
    code: 'p250',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_P250_Inventory_qpprvp.webp'
  },
  {
    name: 'TEC-9',
    code: 'tec9',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Tec-9_Inventory_hpslwl.webp'
  },
  {
    name: 'Five-seven / CZ-75a',
    code: 'fiveseven',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Five-SeveN_Inventory_kkp6wt.webp'
  },
  {
    name: 'Dual Berettas',
    code: 'elite',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Dual_Berettas_Inventory_s93vls.webp'
  },
  {
    name: 'Desert eagle',
    code: 'deagle',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_Desert_Eagle_Inventory_nvtnmx.webp'
  },
  {
    name: 'R8 Revolver',
    code: 'revolver',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/CSGO_R8_Revolver_Inventory_ipmpau.webp'
  },
  {
    name: 'HE Grenade',
    code: 'hegrenade',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Hegrenadehud_csgo_knvs23.webp'
  },
  {
    name: 'Flashbang',
    code: 'flashbang',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Weapon_flashbang_hfjwpa.webp'
  },
  {
    name: 'Smoke',
    code: 'smokegrenade',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Weapon_smokegrenade_uv1yzt.webp'
  },
  {
    name: 'Decoy',
    code: 'decoy',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Decoyhud_csgo_hqpsmj.webp'
  },
  {
    name: 'Molotov',
    code: 'molotov',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Molotovhud_rtlmxv.webp'
  },
  {
    name: 'Incendiary grenade',
    code: 'incgrenade',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Incgrenadehud_csgo_azugu2.webp'
  },
  {
    name: 'Kevlar',
    code: 'vest',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Kevlarhud_csgo_eaqxg0.webp'
  },
  {
    name: 'Helmet',
    code: 'vesthelm',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Helmet_csgo_rqmoa8_b82drd.webp'
  },
  {
    name: 'Defuse kit',
    code: 'defuser',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Defuserhud_csgo_gfobrw.webp'
  },
  {
    name: 'Taser',
    code: 'taser',
    image: 'https://res.cloudinary.com/dyghyeimq/image/upload/v1662208806/CSGO_BIND/Taserhud_golhhn.webp'
  },
]
